import {
  EDIT_COURSES_LOADING,
  EDIT_COURSES_SUCCESS,
  EDIT_COURSES_ERROR,
} from "../../../constant/actionTypes";

const editCourseReducer = (state = {}, action) => {
  switch (action.type) {
    case EDIT_COURSES_LOADING: {
      let obj = {
        loading: true,
      };
      return obj;
    }
    case EDIT_COURSES_SUCCESS: {
      let obj = {
        loading: false,
        data: action.response,
      };
      return obj;
    }
    case EDIT_COURSES_ERROR: {
      let obj = {
        loading: false,
        status: action.response,
      };
      return obj;
    }
    default:
      return state;
  }
};

export default editCourseReducer;
